<div class="cardLayout" id="active360Review">
  <ion-row>
    <ion-col size="12">
      <div class="popup-heading">
        <div>
          <p class="fs-16 font_regular">360 Review</p>
        </div>
        <div class="popup-close">
          <button class="download-btn">
            <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
            download
          </button>
          <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
        </div>
      </div>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size="12">
      <div class="cardBox mb-20 mt-20">
        <div class="headingOfShowBox_two font_medium fs-14" [style.background-color]="buttonColorName">
          <ion-row class="p-0">
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
              <div class="display-space-between">
                <div class="font_bold fs-14">360 Review</div>
                <div class="verticle-center">
                  <div class="icon-container">
                    <span class="material-icons mr-10 fs-20 cp">info</span>
                    <div class="tooltip">
                      <div class="info-popup">
                        <div class="p-20">
                          <h4 class="font_semibold">Instructions</h4>
                          <div class="mt-10 ml-20">
                            <ul *ngFor="let data of infoListData">
                              <li class="fs-12 text_gray">{{data.info}}</li>
                            </ul>
                          </div>
                          <div class="info-table mt-20">
                            <table>
                              <thead>
                                <tr>
                                  <th>Question type</th>
                                  <th>Rating</th>
                                  <th>Rating Definition</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Open Ended</td>
                                  <td>1</td>
                                  <td>Good</td>
                                </tr>
                                <tr>
                                  <td>Rating Based</td>
                                  <td>2</td>
                                  <td>Don’t agree</td>
                                </tr>
                                <tr>
                                  <td>Rating Based</td>
                                  <td>3</td>
                                  <td>Partially agree</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <span class="material-icons fs-24 mr-10 cp" (click)="toggleInfoPopup()">info</span> -->
                  <!-- <div *ngIf="showInfoPopup" class="info-popup">
                    <div class="p-20">
                      <h4 class="font_semibold">Instructions</h4>
                      <div class="mt-10 ml-20">
                        <ul *ngFor="let data of infoListData">
                          <li class="fs-12 text_gray">{{data.info}}</li>
                        </ul>
                      </div>
                      <div class="table-container mt-20">
                        <table>
                          <thead>
                            <tr>
                              <th>Question type</th>
                              <th>Rating</th>
                              <th>Rating Definition</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Open Ended</td>
                              <td>1</td>
                              <td>Good</td>
                            </tr>
                            <tr>
                              <td>Rating Based</td>
                              <td>2</td>
                              <td>Don’t agree</td>
                            </tr>
                            <tr>
                              <td>Rating Based</td>
                              <td>3</td>
                              <td>Partially agree</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </ion-col>
          </ion-row>
        </div>
        <div class="p-10">
          <ion-row>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
              <ion-row>
                <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                  <div class="formLabelSemiBoldfs14 mb-5">Year</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                    <input matInput type="text" placeholder="Type Here" [disabled]="true">
                  </mat-form-field>
                </ion-col>

                <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                  <div class="formLabelSemiBoldfs14 mb-5">360 Review</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                    <input matInput type="text" placeholder="Type Here" [disabled]="true">
                  </mat-form-field>
                </ion-col>

                <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                  <div class="formLabelSemiBoldfs14 mb-5">Start date</div>
                  <mat-form-field class="custom-input w-100 mat-height40 mat-input-style mt-10">
                    <input matInput [matDatepicker]="startDatePicker" placeholder="DD/MM/YYYY" [disabled]="true">
                    <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #startDatePicker></mat-datepicker>
                  </mat-form-field>
                </ion-col>
  
                <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                  <div class="formLabelSemiBoldfs14 mb-5">End date</div>
                  <mat-form-field class="custom-input w-100 mat-height40 mat-input-style mt-10">
                    <input matInput [matDatepicker]="endDatePicker" placeholder="DD/MM/YYYY" [disabled]="true">
                    <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #endDatePicker></mat-datepicker>
                  </mat-form-field>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
        </div>
      </div>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size="12">
      <div class="table-container">
        <table>
          <thead [style.background-color]="buttonColorName">
            <tr>
              <th>Function</th>
              <th>Band</th>
              <th>Competancies</th>
              <th>Questions</th>
              <th>Type (open/ rating)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>It</td>
              <td>A</td>
              <td>Problem Solving</td>
              <td>1. How would you rate your experience with our product?</td>
              <td>Rating Base</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ion-col>
  </ion-row>
</div>
